module.exports = __webpack_public_path__ + "static/media/evening-icon.c91473fe.svg";